/* eslint-disable react/destructuring-assignment */
import React, { Component, ErrorInfo, ReactNode } from 'react';

// Material
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Contants
import IMAGES from 'constants/images';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Boundary error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box
          p='0.5rem'
          width='100%'
          height='100%'
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'>
          <Typography variant='h6'>
            Algo deu errado, favor entre em contato com nosso suporte.
          </Typography>
          <Box
            width='100%'
            display='flex'
            alignItems='center'
            justifyContent='center'>
            <img
              src={IMAGES.BACKGROUND_IMAGES.IMAGE_GENERIC_ERROR}
              alt='error'
            />
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
export { ErrorBoundary };
